/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { ContentType, GuideCell as IGuideCell } from 'client-code/grid-guide';

import { DimensionScaler } from '../device/DimensionScaler';
import { POSTER_IMAGE_HEIGHT, POSTER_IMAGE_NAME, POSTER_IMAGE_WIDTH } from '../strings';
import { DateTime } from '../utils';

export class GuideCell {
    /**
     * Collection ID for a given guide cell.
     * @type {string}
     */
    public collectionId: string;

    /**
     * Content ID for a given guide cell.
     * @type {string}
     */
    public contentId: string;

    /**
     * The type of content.
     * @type {ContentType}
     */
    public contentType?: ContentType;

    /**
     * Showing duration in seconds.
     * @type {number}
     */
    public duration: number;

    /**
     * When true, showing should be treated as adult.
     * @type {boolean}
     */
    public isAdult?: boolean;

    /**
     * When true, showing should be treated as new.
     * @type {boolean}
     */
    public isNew?: boolean;

    /**
     * When true, showing supports PPV.
     * @type {boolean}
     */
    public isPPV?: boolean;

    /**
     * The year the movie was released.
     * @type {number}
     */
    public movieYear?: number;

    /**
     * Offer ID for a given guide cell.
     * @type {string}
     */
    public offerId: string;

    /**
     * Showing start time as DateTime object.
     * @type {DateTime}
     */
    public startTime: DateTime;

    /**
     * Showing title.
     * @type {string}
     */
    public title?: string;

    /**
     * When true, showing supports start-over.
     * @type {boolean}
     */
    public isStartover?: boolean;

    /**
     * When true, showing supports catch-up.
     * @type {boolean}
     */
    public isCatchup?: boolean;

    /**
     * When true, showing can be recorded.
     * @type {boolean}
     */
    public isRecordable?: boolean;

    /**
     * poster image url
     * @type {string}
     */
    public posterImageUrl: string;

    public constructor(guideCell: IGuideCell, imageHostBaseUrl: string) {
        this.collectionId = guideCell.collectionId;
        this.contentId = guideCell.contentId;
        this.contentType = guideCell.contentType;
        this.duration = guideCell.duration;
        this.isAdult = guideCell.isAdult;
        this.isNew = guideCell.isNew;
        this.isPPV = guideCell.isPPV;
        this.isRecordable = guideCell.isRecordable;
        this.movieYear = guideCell.movieYear;
        this.offerId = guideCell.offerId;
        this.startTime = new DateTime(guideCell.startTime * 1000);
        this.title = guideCell.title;
        this.isStartover = guideCell.isStartover;
        this.isCatchup = guideCell.isCatchup;
        this.posterImageUrl = `${imageHostBaseUrl}/images/${
            guideCell.collectionId
        }/${POSTER_IMAGE_NAME}${DimensionScaler.getInstance().getScaledWidth(
            POSTER_IMAGE_WIDTH,
        )}x${DimensionScaler.getInstance().getScaledHeight(POSTER_IMAGE_HEIGHT)}`;
    }
}
